import {
  styled, rem
} from 'config/stitches.config'

const SectionContent = styled('div', {
  display: 'block',
  width: '100%',
  marginTop: rem(24),
  '@md': { marginTop: rem(32) }
})

export default SectionContent
